import { queryOptions } from "@tanstack/react-query";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getAllEnginePages, getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import type { McpServer } from "../types";
import { mcpGatewaysKeys } from "./query-keys";

export const fetchMCPGateways = async ({
  client,
}: {
  client: ApiClient;
}): Promise<McpServer[]> => {
  const { items } = await getAllEnginePages<McpServer>(client, "/gateways");
  return items;
};

export const mcpGatewaysQueryOptions = ({
  binding = "project",
  scope,
}: {
  binding?: ScopedBinding;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<McpServer[]>({
    queryKey: mcpGatewaysKeys.list({ binding, scope }),
    queryFn: () => fetchMCPGateways({ client }),
  });
};
